import React from 'react'
import { Col, FormGroup, Row } from 'react-bootstrap'
import { TextAreaBox, Switch, IntBox } from 'fw/forms'
import { DocumentUpload } from 'areas/shared/controls'
import { ReviewUpload, CommentsGrid, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup'
import { Label, Tooltip, ActionButton, Button } from 'fw/components'
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import BusinessNAICSCode from './businessNAICSCodes'
import BusinessStaff from './businessStaff'
import BusinessStaffPopUp from './businessStaffPopUp'
import * as Notifications from 'fw/globals/Notifications'
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import { QueueType, TooltipCode } from 'areas/shared/consts';

class BusinessStructure extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            naicsCodes: [],
            businessStaff: [],
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    addNaicsCode = () => {
        let item = {
            naicsCodeId: 0,
            naicsCode: '',
            naicsDescription: ''
        }

        let form = this.state.form
        form.naicsCodes = form.naicsCodes.concat(item)

        this.updatePostData(form)
    }

    onNaicsCodesRemove = (index) => {
        let form = this.state.form

        form.naicsCodes.splice(index, 1)

        this.updatePostData(form, true)
    }

    onNaicsCodesChange = (index, item) => {
        let form = this.state.form

        form.naicsCodes[index] = item

        this.updatePostData(form, true)
    }

    onBusinessStaffClose = () => {
        this.setState({
            showBusinessStaffPopUp: false
        })
    }

    onBusinessStaffEdit = (index) => {
        this.setState({
            showBusinessStaffPopUp: true,
            currentBusinessStaff: this.state.form.businessStaff[index]
        })
    }

    onBusinessStaffChange = (businessStaff) => {
        let form = this.state.form;

        var index = form.businessStaff.findIndex(function (element) {
            return element.businessFunctionId === businessStaff.businessFunctionId;
        })

        if (index >= 0) form.businessStaff[index] = businessStaff;
        else form.businessStaff = form.businessStaff.concat(businessStaff);

        if (businessStaff.businessStructureStaffId > 0) Notifications.success('The Staff Member has been updated.');
        else Notifications.success('The Staff Member has been added.')

        this.updatePostData(form, true)
    }

    onBusinessStaffGridChange = (businessStaff) => {
        let form = this.state.form;

        var index = form.businessStaff.findIndex(function (element) {
            return element.businessFunctionId === businessStaff.businessFunctionId
        })

        form.businessStaff[index] = businessStaff;

        this.updatePostData(form, true)
    }

    newBusinessStaff = () => {
        let item = {
            businessStructureStaffId: this.businessStructureStaffId,
            firstName: '',
            lastName: '',
            title: '',
            businessFunctionId: null,
            functionName: '',
            otherFunction: '',
            email: '',
            phones: []
        }

        this.businessStructureStaffId--
        return item
    }

    updatePostData = (form, dirty) => {
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    validateReviewStatus = (form) => {
        let canComplete=
            (
                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
            ) ||
            (
                (this.state.form.subsidiary ? (this.state.form.subsidiaryFile ? this.state.form.subsidiaryFile.validDocument : false) : true) &&
                (this.state.form.otherAgreement ? (this.state.form.otherAgreementFile ? this.state.form.otherAgreementFile.validDocument : false) : true) &&
                (this.state.form.otherAgreement ? (this.state.form.otherAgreementMembers ? this.state.form.otherAgreementMembers.validDocument : false) : true) &&
                (this.state.form.otherAgreement ? (this.state.form.otherAgreementOwner ? this.state.form.otherAgreementOwner.validDocument : false) : true)
            );

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getBusinessStructure'),
            save: API.Admin.url('/certification/saveBusinessStructure')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            entityId: this.state.form.savedEntityId,
            capabilitiesStatement: this.state.form.capabilitiesStatement,
            professionalAccreditation: this.state.form.professionalAccreditation,
            shareResources: this.state.form.shareResources,
            shareResourcesDescription: this.state.form.shareResourcesDescription,
            subsidiary: this.state.form.subsidiary,
            otherAgreement: this.state.form.otherAgreement,
            amountFullTimeEmployee: this.state.form.amountFullTimeEmployee,
            amountVeteranEmployee: this.state.form.amountVeteranEmployee,
            amountPartTimeEmployee: this.state.form.amountPartTimeEmployee,
            amountContractor: this.state.form.amountContractor,
            capabilitiesStatementStorageToken: this.state.form.capabilitiesStatementStorageToken,
            capabilitiesStatementFileName: this.state.form.capabilitiesStatementFileName,
            professionalAccreditationStorageToken: this.state.form.professionalAccreditationStorageToken,
            professionalAccreditationFileName: this.state.form.professionalAccreditationFileName,
            subsidiaryFile: this.state.form.subsidiaryFile,
            otherAgreementFile: this.state.form.otherAgreementFile,
            otherAgreementMembers: this.state.form.otherAgreementMembers,
            otherAgreementOwner: this.state.form.otherAgreementOwner,
            businessStaff: this.state.form.businessStaff,
            naicsCodes: this.state.form.naicsCodes,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    ready = () => {
        this.focusControl && this.focusControl.focus()

        if (this.state.form.naicsCodes.length === 0) {
            this.addNaicsCode()
        }

        this.setState({
            showBusinessStaffPopUp: false,
            currentBusinessStaff: this.newBusinessStaff()
        });
    }

    handleSubsidiaryUploadChange = (file) => {
        let form = this.state.form;
        form.subsidiaryFile = file;

        this.updatePostData(form, true);
    }

    handleOtherAgreementUploadChange = (file) => {
        let form = this.state.form;
        form.otherAgreementFile = file;

        this.updatePostData(form, true);
    }

    handleOtherAgreementMembersUploadChange = (file) => {
        let form = this.state.form;
        form.otherAgreementMembers = file;

        this.updatePostData(form, true);
    }

    handleOtherAgreementOwnerUploadChange = (file) => {
        let form = this.state.form;
        form.otherAgreementOwner = file;

        this.updatePostData(form, true);
    }

    handleCapabilitiesStatementUploadChange = (file) => {
        let form = this.state.form
        form.capabilitiesStatementStorageToken = file.storageToken
        form.capabilitiesStatementFileName = file.fileName

        this.updatePostData(form, true)
    }

    handleProfessionalAccreditationUploadChange = (file) => {
        let form = this.state.form
        form.professionalAccreditationStorageToken = file.storageToken
        form.professionalAccreditationFileName = file.fileName

        this.updatePostData(form, true)
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: 'BusinessStructureInfoReport',
            format: 'PDF',
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        })

        ReportManager.execute(rq)
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    checkBlankQuestion1Fields = () => {
        let form = this.state.form;
        if (!this.state.form.shareResources)
            form.shareResourcesDescription = null;

        this.updatePostData(form, true)
    }

    checkBlankQuestion2Fields = () => {
        let form = this.state.form;
        if (!this.state.form.subsidiary) {
            form.subsidiaryStorageToken = null;
            form.subsidiaryFileName = null;
        }

        this.updatePostData(form, true)
    }

    checkBlankQuestion3Fields = () => {
        let form = this.state.form;
        if (!this.state.form.otherAgreement) {
            form.otherAgreementStorageToken = null;
            form.otherAgreementFileName = null;
            form.otherAgreementMembersStorageToken = null;
            form.otherAgreementMembersFileName = null;
            form.otherAgreementOwnerStorageToken = null;
            form.otherAgreementOwnerFileName = null;
        }

        this.updatePostData(form, true)
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'BS'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        let me = this;

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Capabilities Statement
                                    <small className='required-indicator'> *</small> 
                                    <Label tip={me.setTip(TooltipCode.BUSINESS.CAPSTATEMENT)} />
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting &&
                                        <div className='pull-right'>
                                            <ActionButton id='btnPrint' onClick={this.handlePrint} icon='print' bsSize='sm'>
                                                Print
                                            </ActionButton>
                                        </div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8} style={{ marginTop: '5px' }}>
                                <TextAreaBox required name='capabilitiesStatement' maxLength={10000} rows={4}
                                    placeholder="Please describe your Products and Services. It’s important to note that this statement will be used by Corporate Members to match your capabilities with their needs" />
                            </Col>
                            <Col md={4}>
                                <Label tip={me.setTip(TooltipCode.BUSINESS.CAPUPLOAD)}>Capabilities Upload</Label>
                                <DocumentUpload
                                    storageToken={this.state.form.capabilitiesStatementStorageToken}
                                    fileName={this.state.form.capabilitiesStatementFileName}
                                    onChange={this.handleCapabilitiesStatementUploadChange}
                                    wrapFileNameLength={40}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>
                                    Professional Accreditation
                                    <Label tip={me.setTip(TooltipCode.BUSINESS.PROFACCREDITATION)} />
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8} style={{ marginTop: '5px' }}>
                                <TextAreaBox name='professionalAccreditation' maxLength={5000} rows={4}
                                    placeholder="Please describe any Certificates or Accreditation your business holds" />
                            </Col>
                            <Col md={4}>
                                <Label tip={me.setTip(TooltipCode.BUSINESS.ACRUPLOAD)}>Accreditation Upload</Label>
                                <DocumentUpload
                                    storageToken={this.state.form.professionalAccreditationStorageToken}
                                    fileName={this.state.form.professionalAccreditationFileName}
                                    onChange={this.handleProfessionalAccreditationUploadChange}
                                    wrapFileNameLength={40}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>Business Relationships</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label tip={me.setTip(TooltipCode.BUSINESS.SHARERESQUESTION)}>
                                                Does the Company share any resources with other firms or individuals?
                                            </Label>
                                            <Switch onChange={this.checkBlankQuestion1Fields} name='shareResources' labelLeft='No' labelRight='Yes' bsStyle='primary' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label tip={me.setTip(TooltipCode.BUSINESS.SUBSIDIARYQUESTION)}>
                                                Is this company a subsidiary of another company?
                                            </Label>
                                            <Switch onChange={this.checkBlankQuestion2Fields} name='subsidiary' labelLeft='No' labelRight='Yes' bsStyle='primary' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label tip={me.setTip(TooltipCode.BUSINESS.OTHERAGREEMENT)}>
                                                Does this business, owner or employee intend to enter into any form of agreement with any other business, which would affect the administration, management or operations?
                                            </Label>
                                            <Switch onChange={this.checkBlankQuestion3Fields} name='otherAgreement' labelLeft='No' labelRight='Yes' bsStyle='primary' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6}>
                                {this.state.form.shareResources ? (
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label tip={me.setTip(TooltipCode.BUSINESS.SHARERESDESC)} required>Please explain (500 characters maximum)</Label>
                                                <TextAreaBox required name='shareResourcesDescription' maxLength={500} rows={3} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                ) : null}
                                {this.state.form.subsidiary ? (
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label tip={me.setTip(TooltipCode.BUSINESS.SUBSIDIARYDESC)} required>
                                                    Please upload a list of companies, and a brief description of the relationship with each. Please remember to include each business name, address (business and mailing), telephone numbers and names of contacts.
                                                </Label>
                                                <ReviewUpload
                                                    formatInline={false}
                                                    reviewUpload={me.state.form.subsidiaryFile}
                                                    // config={UploadsConfig}
                                                    onChange={formUpload => me.handleSubsidiaryUploadChange(formUpload)}
                                                    notApplicableAvailable={false}
                                                    wrapFileNameLength={30}
                                                    queueTypeCode={this.state.form.certificationQueueTypeCode}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                ) : null}
                                {this.state.form.otherAgreement ? (
                                    <React.Fragment>
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label tip={me.setTip(TooltipCode.BUSINESS.AGRUPLOAD)} required>
                                                        Please upload a copy of any agreement, or explanation of any agreement (oral or intended).
                                                    </Label>
                                                    <ReviewUpload
                                                        formatInline={false}
                                                        reviewUpload={me.state.form.otherAgreementFile}
                                                        // config={UploadsConfig}
                                                        onChange={formUpload => me.handleOtherAgreementUploadChange(formUpload)}
                                                        notApplicableAvailable={false}
                                                        wrapFileNameLength={30}
                                                        queueTypeCode={this.state.form.certificationQueueTypeCode}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label tip={me.setTip(TooltipCode.BUSINESS.AFFECTEDLISTUPOAD)} required>
                                                        Please upload a list of those who would be affected by the above agreement.
                                                        Please include the titles of all owners, members, corporate shareholders and limited liability members.
                                                     </Label>
                                                    <ReviewUpload
                                                        formatInline={false}
                                                        reviewUpload={me.state.form.otherAgreementMembers}
                                                        // config={UploadsConfig}
                                                        onChange={formUpload => me.handleOtherAgreementMembersUploadChange(formUpload)}
                                                        notApplicableAvailable={false}
                                                        wrapFileNameLength={30}
                                                        queueTypeCode={this.state.form.certificationQueueTypeCode}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label tip={me.setTip(TooltipCode.BUSINESS.COLISTUPLOAD)} required>
                                                        Please upload a list of any company owner or manager associated with another business. Please include a brief description for each business, as well as the relationship of the owner or manager to the business. Please include the business name, address (business and mailing), telephone numbers and names of contacts.
                                                    </Label>
                                                    <ReviewUpload
                                                        formatInline={false}
                                                        reviewUpload={me.state.form.otherAgreementOwner}
                                                        // config={UploadsConfig}
                                                        onChange={formUpload => me.handleOtherAgreementOwnerUploadChange(formUpload)}
                                                        notApplicableAvailable={false}
                                                        wrapFileNameLength={30}
                                                        queueTypeCode={this.state.form.certificationQueueTypeCode}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </React.Fragment>) : null}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <Label>
                                     <h3>
                                        NAICS Codes
                                        <small className="required-indicator"> *</small>
                                    </h3>
                                </Label>
                                { me.setTip(TooltipCode.BUSINESS.NAICSCODES) && <Tooltip tip={me.setTip(TooltipCode.BUSINESS.NAICSCODES)}/> }
                                <hr />
                             </Col>
                        </Row>
                        <Row>
                            <Col md={9}>
                                <BusinessNAICSCode naicsCodes={this.state.form.naicsCodes}
                                    onRemove={this.onNaicsCodesRemove}
                                    onChange={this.onNaicsCodesChange} />
                            </Col>
                            <Col md={3}>
                                <a href="https://www.naics.com/search/" target="_blank" rel="noopener noreferrer">See current NAICS Codes here</a>
                            </Col>
                        </Row>
                        {this.state.enabled && <Row>
                            <Col md={12}>
                                <br />
								<Button type="button" bsStyle="link" onClick={() => this.addNaicsCode()}>
									Add more NAICS Codes
								</Button>
                            </Col>
                        </Row>}
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>Staff &amp; Responsibilities – <small>Please identify primary decision makers within your Company</small>
                                    <small className="required-indicator"> *</small></h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <BusinessStaffPopUp
                                    visible={this.state.showBusinessStaffPopUp}
                                    onClose={this.onBusinessStaffClose}
                                    onSave={this.onBusinessStaffChange}
                                    currentBusinessStaff={this.state.currentBusinessStaff} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <BusinessStaff
                                    disabled={!this.state.enabled}
                                    businessStaff={this.state.form.businessStaff}
                                    majorityOwner={this.state.form.majorityOwner}
                                    onEdit={this.onBusinessStaffEdit}
                                    onChange={this.onBusinessStaffGridChange} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}><br /></Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label tip={me.setTip(TooltipCode.BUSINESS.NUMBERFULLTIMEEE)}>
                                        Number of Full-Time Employees
                                    </Label>
                                    <IntBox
                                        name="amountFullTimeEmployee"
                                        placeholder="# Full-Time Employees"
                                        maxLength={9}
                                        style={{ width: "200px" }} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label tip={me.setTip(TooltipCode.BUSINESS.NUMBERVETERANEE)}>
                                        Number of Veteran Employees
                                    </Label>
                                    <IntBox
                                        name="amountVeteranEmployee"
                                        placeholder="# Veteran Employees"
                                        maxLength={9}
                                        style={{ width: "200px" }} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label tip={me.setTip(TooltipCode.BUSINESS.NUMBERPARTTIMEEE)}>
                                        Number of Part-Time Employees
                                    </Label>
                                    <IntBox
                                        name="amountPartTimeEmployee"
                                        placeholder="# Part-Time Employees"
                                        maxLength={9}
                                        style={{ width: "200px" }} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label tip={me.setTip(TooltipCode.BUSINESS.NUMBERPARTTIMECTR)}>
                                        Number of Contractor(s) or 1099 Recipients
                                    </Label>
                                    <IntBox
                                        name="amountContractor"
                                        placeholder="# Contractor/1099 Employees"
                                        maxLength={9}
                                        style={{ width: "200px" }} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {this.state.form.showReview ?
                    <React.Fragment>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={"BS"}
                                queueTypeCode={this.state.form.certificationQueueTypeCode}
                                enableExport={true}
                                entityId={this.state.form.savedEntityId}
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid} 
                                onCommentChange={this.handleCommentChange} />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Business Structure"
                                    canComplete={
                                        (
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                        (
                                            (this.state.form.subsidiary ? (this.state.form.subsidiaryFile ? this.state.form.subsidiaryFile.validDocument : false) : true) &&
                                            (this.state.form.otherAgreement ? (this.state.form.otherAgreementFile ? this.state.form.otherAgreementFile.validDocument : false) : true) &&
                                            (this.state.form.otherAgreement ? (this.state.form.otherAgreementMembers ? this.state.form.otherAgreementMembers.validDocument : false) : true) &&
                                            (this.state.form.otherAgreement ? (this.state.form.otherAgreementOwner ? this.state.form.otherAgreementOwner.validDocument : false) : true)
                                        )
                                    }
                                    onChange={this.handleReviewStatus}
                                    reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                            : null}
                    </React.Fragment>
                    : null}
            </React.Fragment>
        )
    }
}

export default BusinessStructure



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/businessStructure/BusinessStructure.js